import { FigureVarSettings, isFigureVarSettings } from "./FigureVarSettings";

export interface FigureRegressionLineSettings {
  lineType: string;
  parameters: FigureVarSettings[];
}

/**
 * Type guard to check if an object is a FigureTypeRegressionLineSettings
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureTypeRegressionLineSettings
 */
export const isFigureRegressionLineSettings = (
  obj: unknown,
): obj is FigureRegressionLineSettings => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureRegressionLineSettings;
  if (typeof chkObj.lineType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.parameters)) {
    return false;
  }
  if (chkObj.parameters.some((param) => !isFigureVarSettings(param))) {
    return false;
  }
  return true;
};
